import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import SpecialProgressChartForKPI03 from "./SpecialProgressChartForKPI03";
import SpecialAreaChartForKPI04 from "./SpecialAreaChartForKPI04";
import SpecialBarChartForKPI05 from "./SpecialBarChartForKPI05";
import SpecialLineChartForKPI06 from "./SpecialLineChartForKPI06";

const SpecialKPIChart = ({ kpi }) => {
  const series = [
    kpi.avg_target_performance,
    kpi.avg_actual_performance,
    kpi.avg_internal_benchmark,
    kpi.avg_external_benchmark,
    kpi.avg_new_target_performance,
  ];

  const labels = [
    "Avg Target",
    "Avg Actual",
    "Internal Benchmark",
    "External Benchmark",
    "New Target",
  ];

  const options = {
    chart: {
      type: "radar",
    },
    labels: labels,
    stroke: {
      width: 2,
    },
    fill: {
      opacity: 0.3,
    },
    colors: ["#00b894"],
  };

  return (
    <div className="special-kpi-chart" style={{ marginBottom: 30 }}>
      <h5 style={{ textAlign: "center" }}>{kpi.kpi_code}</h5>
      <ReactApexChart
        options={options}
        series={[{ name: "Values", data: series }]}
        type="radar"
        height={300}
      />
    </div>
  );
};

// الشكل الافتراضي لباقي المؤشرات
const DefaultKPIChart = ({ kpi }) => {
  const series = [
    kpi.avg_target_performance,
    kpi.avg_actual_performance,
    kpi.avg_internal_benchmark,
    kpi.avg_external_benchmark,
    kpi.avg_new_target_performance,
  ];

  const labels = [
    "Avg Target",
    "Avg Actual",
    "Internal Benchmark",
    "External Benchmark",
    "New Target",
  ];

  const options = {
    chart: { type: "polarArea", sparkline: { enabled: true } },
    labels: labels,
    fill: {
      opacity: 1,
      colors: ["#363062", "#21b830", "#ff7a00", "#ffe600", "#007bff"],
    },
    stroke: { width: 0 },
    yaxis: { show: false },
    legend: { position: "bottom" },
    plotOptions: {
      polarArea: { rings: { strokeWidth: 0 } },
    },
  };

  return (
    <div className="kpi-chart" style={{ marginBottom: 30 }}>
      <h5 style={{ textAlign: "center" }}>{kpi.kpi_code}</h5>
      <ReactApexChart
        options={options}
        series={series}
        type="polarArea"
        height={250}
      />
    </div>
  );
};

const KPIChartsContainer = ({ selectedYear }) => {
  const [kpis, setKpis] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedYear) return;

    setLoading(true);
    fetch(
      `https://plo.areez.co/api/kpi/averages/by_code?academic_year_id=${selectedYear}`
    )
      .then((res) => {
        if (!res.ok) throw new Error("فشل في تحميل بيانات المؤشرات");
        return res.json();
      })
      .then((data) => setKpis(data))
      .catch((err) => {
        console.error(err);
        setKpis([]);
      })
      .finally(() => setLoading(false));
  }, [selectedYear]);

  return (
    <>
      <div
        className="kpi-charts-container"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
          gap: 20,
        }}
      >
        {kpis.map((kpi) => {
          if (kpi.kpi_code === "KPI-I-01") {
            return <DefaultKPIChart key={kpi.kpi_code} kpi={kpi} />;
          } else if (kpi.kpi_code === "KPI-I-02") {
            return <SpecialKPIChart key={kpi.kpi_code} kpi={kpi} />;
          } else if (kpi.kpi_code === "KPI-I-03") {
            return (
              <SpecialProgressChartForKPI03 key={kpi.kpi_code} kpi={kpi} />
            );
          } else {
            return null;
          }
        })}
      </div>

      <div className="row">
        {kpis.map((kpi) => {
          if (kpi.kpi_code === "KPI-I-04") {
            return (
              <div className="col-12 col-lg-6" key={kpi.kpi_code}>
                <SpecialAreaChartForKPI04 kpi={kpi} />
              </div>
            );
          } else if (kpi.kpi_code === "KPI-I-05") {
            return (
              <div className="col-12 col-lg-6" key={kpi.kpi_code}>
                <SpecialBarChartForKPI05 kpi={kpi} />
              </div>
            );
          } else if (kpi.kpi_code === "KPI-I-06A") {
            return (
              <div className="col-12 col-lg-6" key={kpi.kpi_code}>
                <SpecialLineChartForKPI06 kpi={kpi} />
              </div>
            );
          } else if (kpi.kpi_code === "KPI-I-06B") {
            return (
              <div className="col-12 col-lg-6 mb-3" key={kpi.kpi_code}>
                <SpecialLineChartForKPI06 kpi={kpi} />
              </div>
            );
          } else if (kpi.kpi_code === "KPI-I-07") {
            return (
              <div className="col-12 col-lg-6 mt-3" key={kpi.kpi_code}>
                <DefaultKPIChart key={kpi.kpi_code} kpi={kpi} />;
              </div>
            );
          } else if (kpi.kpi_code === "KPI-I-08") {
            return (
              <div className="col-12 col-lg-6" key={kpi.kpi_code}>
                <SpecialAreaChartForKPI04 kpi={kpi} />
              </div>
            );
          } else if (kpi.kpi_code === "KPI-I-09") {
            return (
              <div className="col-12 col-lg-6" key={kpi.kpi_code}>
                <SpecialBarChartForKPI05 kpi={kpi} />
              </div>
            );
          } else if (kpi.kpi_code === "KPI-I-10") {
            return (
              <div className="col-12 col-lg-6" key={kpi.kpi_code}>
                <SpecialLineChartForKPI06 kpi={kpi} />
              </div>
            );
          } else if (kpi.kpi_code === "KPI-I-11") {
            return (
              <div className="col-12 col-lg-6 mt-5" key={kpi.kpi_code}>
                <SpecialProgressChartForKPI03 key={kpi.kpi_code} kpi={kpi} />
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    </>
  );
};

export default KPIChartsContainer;
